<template>
  <div class="flex flex-col items-center justify-center text-center gap-4 min-h-[50vh]">
    <div class="uppercase">
      No events found
    </div>
    <h4 class="text-4.5xl">
      Sorry, there are no events for<br/> this search! Try again.
    </h4>
  </div>
</template>

